import apiClient from './config';

const voucherApi = {
  // Get voucher by token code
  getVoucherByToken: async (tokenCode) => {
    try {
      const response = await apiClient.get(`/voucher-token?token_code=${tokenCode}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Submit order checkin
  submitOrderCheckin: async (orderData) => {
    try {
      const response = await apiClient.post('/order-checkin', orderData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default voucherApi; 